import React, { useEffect, useState } from 'react';
import './LandingPage.css';

const LandingPage: React.FC = () => {
  const [words, setWords] = useState<string[]>([]);

  const wordList = [
    "Innovate", "Create", "Dream", "Explore", "Discover", 
    "Inspire", "Achieve", "Empower", "Evolve", "Imagine",
    "Adventure", "Connect", "Transform", "Thrive", "Unite",
    "Elevate", "Explore", "Journey", "Believe", "Aspire",
    "Succeed", "Passion", "Unleash", "Rise", "Lead",
    "Challenge", "Invention", "Growth", "Vision", "Future",
    "Freedom", "Purpose", "Strength", "Ambition", "Victory",
    "Momentum", "Harmony", "Focus", "Power", "Courage",
    "Clarity", "Dare", "Pursue", "Venture", "Gratitude",
    "Radiance", "Resilience", "Balance", "Commitment", "Optimism"
  ];

  // Generate random words on the screen
  useEffect(() => {
    const interval = setInterval(() => {
      const randomWord = wordList[Math.floor(Math.random() * wordList.length)];
      setWords((prevWords) => [...prevWords, randomWord]);
    }, 2000); // Add a new word every 4 seconds

    return () => clearInterval(interval);
  }, [words]);

  return (
    <div className="landing-container">
      <div className="words-container">
        {words.map((word, index) => (
          <div
            key={index}
            className="random-word"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${0}s`,
            }}
          >
            {word}
          </div>
        ))}
      </div>
      <div className="landing-card">
        <img src="app-icon.png" alt="App Logo" className="landing-logo" />
        <h1 className="landing-title">Flashcards - Expand English</h1>
        <p className="landing-subtitle">Learn & Repeat English Words</p>
        <a href="https://apps.apple.com/pl/app/flashcards-expand-english/id6474883971" className="app-store-button">
          Download on the App Store
        </a>
      </div>
      <div className="footnote">Weglowa504 all rights reserved</div>
      <div className="privacy-button">
        <a href="https://flashcards.cam/privacy" className="privacy-link">Privacy Policy</a>
      </div>
    </div>
  );
};

export default LandingPage;
